import gql from 'not-graphql-tag';

export const getIFrameInfo = gql`
  query getIFrameInfo($payload: IFrameInfoRequest!) {
    getIFrameInfo(payload: $payload) {
      src
    }
  }
`;

export const listProfiles = gql`
  query listProfiles($payload: ListProfilesRequest) {
    listProfiles(payload: $payload) {
      listProfilesResponse {
        profile {
          token
          type
          accountNumber
          creditCardExpiryDate {
            month
            year
          }
          cardHolderName
          default
          usedForAutopay
          hasDeferredPayments
        }
      }
    }
  }
`;

export const deleteProfile = gql`
  mutation deleteProfile($payload: DeleteProfileRequest!) {
    deleteProfile(payload: $payload) {
      profileResponse {
        status
        token
      }
    }
  }
`;
